module.exports = __webpack_public_path__ + "img/2.fbe77aad.png";